import {
  Activity,
  ArrowDownToLine,
  Cable,
  ClipboardCheck,
  CloudLightning,
  FileText,
  FolderKanban,
  Gauge,
  Home,
  LayoutPanelTop,
  Radio,
  Route,
  ShieldAlert,
  ShieldCheck,
  Waves,
  Zap,
  type LucideIcon,
} from "lucide-react";

import type { ModuleIconName } from "../app/modules";

// The icon of a module in the sidebar and on the home cards (Master Prompt A25 (e)):
// Lucide (ISC), hidden from assistive technology, beside the module's name that carries
// the meaning. The registry names the icon (modules.ts); this map renders it.

const ICONS: Record<ModuleIconName | "Home", LucideIcon> = {
  FolderKanban,
  Gauge,
  Zap,
  Activity,
  ShieldCheck,
  Cable,
  LayoutPanelTop,
  ArrowDownToLine,
  CloudLightning,
  ShieldAlert,
  Waves,
  Route,
  FileText,
  ClipboardCheck,
  Radio,
  Home,
};

type ModuleIconProps = {
  name: ModuleIconName | "Home";
  size?: 18 | 22;
};

export function ModuleIcon({ name, size = 18 }: ModuleIconProps) {
  const Icon = ICONS[name];
  return (
    <Icon aria-hidden="true" focusable="false" data-module-icon={name} size={size} strokeWidth={2} />
  );
}

export { ICONS as MODULE_ICONS };

export default ModuleIcon;
